// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"oo_a bhl_qr bhl_a bhl_w","FaqAskQuestion__outdated":"oo_b bhl_vp bhl_xe"};